import { supabase } from './supabase';

// People the current user can assign work to: their own profile plus the
// co-members of every context they belong to (scoped by the profiles RLS
// policy). Cached for the session — membership changes rarely, and a page
// reload picks up anyone new.
let cache = null;
let inflight = null;

export const cachedMembers = () => cache;

export const getMembers = async () => {
  if (cache) return cache;
  if (!inflight) {
    inflight = supabase
      .from('profiles')
      .select('id, full_name, email, avatar_url')
      .order('full_name', { ascending: true, nullsFirst: false })
      .then(({ data }) => {
        cache = data || [];
        inflight = null;
        return cache;
      });
  }
  return inflight;
};
